import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d0fe1e23-c8d3-4550-ab3a-c315f9ea2497", content: "2nd order low-pass filter.", options: {} },
  { id: "bd7b9662-81c9-4cd7-978b-173f183c6510", content: "4th order low-pass filter.", options: {} },
  { id: "1de7b15c-508a-4e4b-b854-6a22fe498107", content: "2nd order band-pass filter.", options: {} },
  { id: "f28586e2-467b-4bf4-993f-e96bff8f251a", content: "4th order band-pass filter.", options: {} },
  { id: "61f0de57-5065-4226-9b1c-616cab74f266", content: "2nd order high-pass filter.", options: {} },
  { id: "6f3297cb-3d79-482c-8463-0e00544c5362", content: "4th order high-pass filter.", options: {} },
];

export const task: Task = {
  id: "7b2c7dd8-db65-41af-9d88-e0657088ec84",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f28586e2-467b-4bf4-993f-e96bff8f251a"],
};
